import { render, staticRenderFns } from "./AppAflossenHypotheekdeelInfo.vue?vue&type=template&id=3012d249&scoped=true&"
import script from "./AppAflossenHypotheekdeelInfo.ts?vue&type=script&lang=ts&"
export * from "./AppAflossenHypotheekdeelInfo.ts?vue&type=script&lang=ts&"
import style0 from "./AppAflossenHypotheekdeelInfo.scss?vue&type=style&index=0&id=3012d249&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3012d249",
  null
  
)

export default component.exports